import { atom, useRecoilState } from "recoil";

const claimDrawerState = atom({
  key: "claimDrawerState",
  default: false,
});

export const useClaimDrawerStore = () => {
  const [isOpen, setIsOpen] = useRecoilState(claimDrawerState);

  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

  return {
    isOpen,
    onOpen,
    onClose,
  };
};
